import { Link } from 'react-router-dom'
import './Footer.css'

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.258 5.622L18.244 2.25z"/>
  </svg>
)

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
)

const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.29 8.29 0 0 0 4.83 1.55V6.78a4.85 4.85 0 0 1-1.06-.09z"/>
  </svg>
)

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">

        <div className="footer__left" />

        <div className="footer__center">
          <span className="footer__copy">© 2026 StellarFM</span>
          <span className="footer__sep">·</span>
          <Link to="/mentions-legales" className="footer__link">Mentions légales</Link>
        </div>

        <div className="footer__right">
          <a
            href="https://x.com/StellarFM"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__social"
            title="X (Twitter)"
          >
            <XIcon />
          </a>
          <a
            href="https://instagram.com/StellarFM"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__social"
            title="Instagram"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://tiktok.com/@StellarFM"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__social"
            title="TikTok"
          >
            <TikTokIcon />
          </a>
        </div>

      </div>
    </footer>
  )
}
